
import { computed, defineComponent, onMounted, ref, watch } from 'vue'
import useState from '@/useState';
import UserTable from './table.vue'
import Search from './Search.vue'
import SelectedMenu from './SelectedMenu.vue';
import { InputSearch, Input, Popover, Dropdown, Menu, MenuItem } from 'ant-design-vue'
import { CaretDownOutlined, SearchOutlined } from '@ant-design/icons-vue'
import 'ant-design-vue/lib/input/style/css'
import 'ant-design-vue/lib/popover/style/css'
import 'ant-design-vue/lib/dropdown/style/css'
import 'ant-design-vue/lib/menu/style/css'
import { MainModule, TableFilterModel } from '@/store/modules/main.store'

export default defineComponent({
    components: {
        Search,
        UserTable,
        InputSearch,
        Popover,
        CaretDownOutlined,
        Input,
        SearchOutlined,
        Dropdown,
        Menu,
        MenuItem,
        SelectedMenu
    },
    setup () {
        const tableHeight = ref(500);
        const tableRef = ref<any>(null);
        const searchValue = ref('');
        const sortedInfo = ref();
        const selectRows = ref([]);
        const selectedRowKeys = ref([]);
        const hasSelected = computed(() => {
            return selectedRowKeys.value.length > 0;
        })
        const viewObj = computed(() => {
            return MainModule.getViewObj
        })

        const columns = computed(() => {
            if (!MainModule.viewsColumns[MainModule.viewId]) {
                return [];
            }
            const sorted = sortedInfo.value || {};
            return MainModule.viewsColumns[MainModule.viewId].map((v) => {
                return {
                    ...v,
                    columnKey: v.id,
                    dataIndex: v.id,
                    width: parseInt(v.length, 10),
                    sorter: true,
                    sortOrder: sorted.field === v.id && sorted.order
                }
            });
        })

        const dataList = computed(() => {
          if (!MainModule.viewsData[MainModule.viewId] || !MainModule.viewsData[MainModule.viewId].list) {
            return [];
          }
          return MainModule.viewsData[MainModule.viewId].list;
        })

        const pagination = computed(() => {
          const data = MainModule.filterData[MainModule.viewId];
          if (!data || !MainModule.viewsData[MainModule.viewId]) {
              return {
                  current: 1,
                  pageSize: 20,
                  total: 0,
                  showSizeChanger: false
              }
          } else {
              return {
                  current: data.page,
                  pageSize: data.size,
                  total: MainModule.viewsData[MainModule.viewId].count,
                  showSizeChanger: false,
                  showTotal: (total) => `共计 ${total} 条`
              }
          }
        })

        watch(computed(() => MainModule.viewId), () => {
          searchValue.value = '';
          sortedInfo.value = {};
          selectedRowKeys.value = [];
          selectRows.value = [];
        });

        const onSelectChange = ([values, _selectRows]) => {
          selectedRowKeys.value = values;
          selectRows.value = _selectRows;
        }

        function handleTableChange ({ pagination, filters, sorter }) {
            const { current } = pagination;
            const { field, order } = sorter;
            sortedInfo.value = sorter;
            const params: TableFilterModel = {
              page: current
            }
            if (field && order) {
              params.field = field;
              params.order = order;
            }
            MainModule.changeDataFilter(params);
            console.log(pagination);
            console.log(filters);
            console.log(sorter);
        }

        const handleCancelSelect = () => {
          selectedRowKeys.value = []
          selectRows.value = [];
        }

        function hadleSearch () {
            const searchType = searchValue.value ? 'searchKeyQuery' : '';
            MainModule.changeDataFilter({ searchKey: searchValue.value, searchType });
        }

        function viewNext () {
          if (dataList.value.length === 0) {
            return;
          }
          const ids = dataList.value.map(t => t.id); // 转字串
          const $state = useState();
          $state.go("customers_detail", { id: ids[0], ids: ids, isTraversal: true })
        }
        
        // watch(viewObj, (v) => {
        //     console.log('=======')
        //     console.log({ ...v });
        // })

        onMounted(() => {
          tableHeight.value = tableRef.value.offsetHeight - 100
        })

        return {
            searchValue,
            tableHeight,
            tableRef,
            handleTableChange,
            hadleSearch,
            viewNext,
            columns,
            dataList,
            pagination,
            selectRows,
            selectedRowKeys,
            hasSelected,
            onSelectChange,
            handleCancelSelect,
            viewObj
        }
    }
})
